var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCi22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_730)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_30_730",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 0H0V70H70V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_30_730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8643 65.8984H49.8135V61.5234H21.1025V65.8984H19.0518C17.9182 65.8984 17.001 66.8157 17.001 67.9492C17.001 69.0827 17.9182 70 19.0518 70H51.8643C52.9978 70 53.915 69.0827 53.915 67.9492C53.915 66.8157 52.9978 65.8984 51.8643 65.8984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7551 16.4484L35.4647 15.8677L35.1863 16.4244C34.681 17.4648 33.6579 17.5464 33.6442 17.56L32.9994 17.6562L33.4419 18.0926C33.9275 18.5552 34.1668 19.2528 34.0428 19.9353L33.9407 20.5541L34.5193 20.2536C35.1003 19.9514 35.8104 19.9418 36.4099 20.2536L36.9887 20.5541L36.8825 19.9112C36.7724 19.2523 36.9907 18.5813 37.4654 18.1147L37.93 17.6562L37.285 17.56C36.6241 17.4598 36.0535 17.0453 35.7551 16.4484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9492 4.10156H57.515C57.5321 3.4196 57.5585 2.74477 57.5585 2.05078C57.5585 0.917246 56.6413 0 55.5078 0H14.4922C13.3587 0 12.4414 0.917246 12.4414 2.05078C12.4414 2.74477 12.4679 3.41988 12.485 4.10156H2.05078C0.917246 4.10156 0 5.01881 0 6.15235V11.3474C0 22.7963 9.16973 32.0965 20.4716 32.698C22.8285 35.94 25.635 38.3467 28.8116 39.7138C28.3458 49.0715 23.3808 55.5528 21.7747 57.4217H48.2221C46.6165 55.5658 41.6524 49.1231 41.1865 39.7138C44.3641 38.3472 47.1719 35.9404 49.5291 32.698C60.8302 32.0963 70 22.7962 70 11.3474V6.15235C70 5.01881 69.0828 4.10156 67.9492 4.10156ZM4.10156 11.3474V8.20312H12.6892C13.301 16.0165 15.0787 22.8664 17.7957 28.2609C10.0511 26.517 4.10156 19.6113 4.10156 11.3474ZM43.2672 17.698L40.6377 20.2874L41.2426 23.9283C41.3708 24.6954 41.0543 25.4686 40.4255 25.9231C39.7945 26.3813 38.9654 26.4424 38.2746 26.0854L35 24.385L31.7256 26.0854C31.0327 26.4378 30.2035 26.3797 29.5748 25.9231C28.9458 25.4686 28.6294 24.6955 28.7575 23.9283L29.3624 20.2874L26.7329 17.698C26.1687 17.1422 25.9873 16.322 26.2222 15.6031C26.4626 14.8661 27.0994 14.3254 27.8685 14.2093L31.5174 13.6605L33.1656 10.3621C33.8585 8.97217 36.1417 8.97217 36.8346 10.3621L38.483 13.6605L42.1318 14.2093C42.9008 14.3255 43.5377 14.8662 43.778 15.6031C44.0182 16.3421 43.82 17.1533 43.2672 17.698ZM65.8985 11.3474C65.8985 19.6111 59.9488 26.5167 52.2046 28.2606C54.9213 22.8662 56.6992 16.0167 57.3107 8.20312H65.8985V11.3474Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCi22);
export default __webpack_public_path__ + "static/media/ci-2-2.b3520f7497da036c8c0574b871a536ed.svg";
export { ForwardRef as ReactComponent };